module.exports = __webpack_public_path__ + "static/media/wolverhampton.7da7a5b9.png";